module.exports = __webpack_public_path__ + "img/ClickForSound_2.5dcb4e43.png";